import {ProductCategory} from "./productCategory";
import {ProductImage} from "./ProductImage";
import {ProductBarcode} from "./productBarcode";

export class Product {

    id?: string;
    name: string = '';
    companyId: string = '';
    images?: ProductImage[];
    fullPrice?: number;
    reducedPrice?: number;
    quantity?: number;
    categories?: ProductCategory[];
    barcode?: ProductBarcode[];
    shortDescription?: string;
    description?: string;
    isVisible?: number;
    coverImage?: string;


    constructor(raw?: any) {
        if (raw) {
            if (raw.id || raw.id !== '') this.id = raw.id
            this.name = raw.name;
            this.fullPrice = parseFloat(raw.fullPrice);
            this.reducedPrice = parseFloat(raw.reducedPrice);
            this.companyId = raw.companyId;
            if (raw.images && raw.images.length > 0) this.images = raw.images;
            if (raw.categories && raw.categories.length > 0) this.categories = raw.categories;
            if (raw.barcode && raw.barcode.length > 0) this.barcode = raw.barcode;
            this.shortDescription = raw.shortDescription;
            this.description = raw.description;
            this.quantity = raw.quantity;
            this.isVisible = raw.isVisible;
            this.coverImage = raw.coverImage;
        }
    }
}
